import axios from 'axios';
import {
  SET_TICKER_INFO,
  LAST_UPDATE_TIME,
  SET_TICKER_NEWS_INFO,
  SET_TICKER_SEARCH_INFO,
  BASE_URL,
  SET_CHART_INFO
} from './types';

export function getTickerInfo() {
  const url = `${BASE_URL()}/api/gettickerinfo`;
  const request = axios.get(url, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    return request.then((response) => {
      dispatch({ type: SET_TICKER_INFO, payload: response });
      dispatch({ type: LAST_UPDATE_TIME });
    });
  }
}

/* TICKER CHARTS */

export function getChartInfo({ symbol, range }) {
  const url = `${BASE_URL()}/api/getchartinfo/${symbol}/${range}`;
  const request = axios.get(url, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    dispatch(setChartInfo([]));
    request.then((response) => {
      dispatch(setChartInfo(response.data));
    }).catch((err) => {
      console.log('Ticker chart error:', err);
    })
  }
}

function setChartInfo(payload) {
  return {
    type: SET_CHART_INFO,
    payload: payload
  };
}

/* TICKER NEWS */

export function getTickerNewsInfo({ symbol }) {
  const url = `${BASE_URL()}/api/gettickernewsinfo/${symbol}`;
  const request = axios.get(url, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    dispatch(setTickerNewsInfo([]));
    request.then((response) => {
      dispatch(setTickerNewsInfo(response.data));
    }).catch((err) => {
      console.log('Ticker news error:', err);
    })
  }
}

function setTickerNewsInfo(payload) {
  return {
    type: SET_TICKER_NEWS_INFO,
    payload: payload
  };
}

/* TICKER SEARCH INFO */

export function getTickerSearchInfo({ symbol }) {
  const url = `${BASE_URL()}/api/gettickersearchinfo/${symbol}`;
  const request = axios.get(url, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    dispatch(setTickerSearchInfo({}));
    request.then((response) => {
      dispatch(setTickerSearchInfo(response.data));
    }).catch((err) => {
      console.log('Ticker search error:', err);
    })
  }
}

function setTickerSearchInfo(payload) {
  return {
    type: SET_TICKER_SEARCH_INFO,
    payload: payload
  };
}
